import React from 'react';
import { M } from '@dashboard-experience/mastodon';

import IconPanel2 from '../IconPanel2';
import './completed.scss';

const Completed: React.FC<{
  candidateEmail: string;
  matrixFields?: string[];
}> = ({ matrixFields, candidateEmail }) => {
  return (
    <div>
      <IconPanel2
        translationKey='components.Verification.NewCompleted'
        icon={
          <M.Icon
            icon='CheckmarkOutline'
            style={{ fill: '#009BB5', width: 40, height: 40 }}
          />
        }
      />
    </div>
  );
};

export default Completed;
